export type ReportingLevel = 0 | 1 | 2 | 3
export enum ReportingLevels {
	NONE,
	VIEW,
	EXPORT,
	GEOEXPORT
}
